module.exports = __webpack_public_path__ + "static/media/hosting_enterprise.a6f77875.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vector/hosting_enterprise.svg
// module id = 259
// module chunks = 0